import p1 from '../../assets/images/pricing/p1.svg'
import p2 from '../../assets/images/pricing/p2.svg'
import p3 from '../../assets/images/pricing/p3.svg'
import p4 from '../../assets/images/pricing/p4.svg'
import p5 from '../../assets/images/pricing/p5.svg'
import p6 from '../../assets/images/pricing/p6.svg'
import p7 from '../../assets/images/pricing/p7.svg'
import p8 from '../../assets/images/pricing/p8.svg'
import p9 from '../../assets/images/pricing/p9.svg'
import p10 from '../../assets/images/pricing/p10.svg'
import p11 from '../../assets/images/pricing/p11.svg'
import p12 from '../../assets/images/pricing/p12.svg'
import p13 from '../../assets/images/pricing/p13.svg'
import p14 from '../../assets/images/pricing/p14.svg'

export const serviceCategories = [
  {
    id: 'support',
    name: 'Support Services',
    icon: p1,
    color: '#E6FAE6'
  },
  {
    id: 'development',
    name: 'Development Services',
    icon: p2,
    color: '#fef7e0'
  },
  {
    id: 'uiux',
    name: 'UI/UX Services',
    icon: p3,
    color: '#e8f0fe'
  },
  {
    id: 'video',
    name: 'Video Editing Service',
    icon: p4,
    color: '#fdecea'
  }
]

const servicePricingPlans = [
  {
    id: 'basic',
    title: 'Basic Care Plan',
    frequency: 'Per Month',
    priceUSD: '$500',
    priceINR: '₹15,000',
    icon: p5,
    description: '',
    serviceSections: [
      {
        title: 'Server & Infrastructure Support',
        icon: p8,
        items: [
          'Uptime monitoring (24x7 alerts)',
          'Cloud hosting & scaling (AWS/GCP/Azure)',
          'SSL renewal & management',
          'Database backup scheduling & recovery',
          'Server patching & OS updates',
          'CDN integration & monitoring'
        ]
      },
      {
        title: 'Console Management (Play Store / App Store)',
        icon: p9,
        items: [
          'App release & update submissions',
          'Signing certificates & provisioning profiles',
          'App privacy policy / compliance updates',
          'Renewing developer accounts & certificates',
          'Handling version rollbacks if updates fail'
        ]
      },
      {
        title: 'Bug Fixes & Issue Resolution',
        icon: p10,
        items: [
          'Crash and error fixes from user reports',
          'UI/UX fixes post-release',
          'Hotfix releases for urgent bugs',
          'Browser compatibility fixes for web apps',
          'Push notification delivery fixes'
        ]
      },
      {
        title: 'Monitoring & Analytics',
        icon: p11,
        items: [
          'Crash reporting setup & checks',
          'App analytics setup (Firebase, Mixpanel, Amplitude)',
          'Error tracking integration',
          'Monthly performance reports'
        ]
      },
      {
        title: 'Compliance & Security Support',
        icon: p12,
        items: [
          'Privacy policy & Terms updates in app',
          'Play Store / App Store policy compliance',
          'SDK license renewals & new rules'
        ]
      },
      {
        title: 'Other Support Services',
        icon: p13,
        items: ['Release notes for app updates']
      }
    ]
  },
  {
    id: 'growth',
    title: 'Growth Care Plan - Maintain & Improve',
    frequency: 'Per Month',
    priceUSD: '$1200',
    priceINR: '₹32,000',
    icon: p6,
    description: '',
    serviceSections: [
      {
        title: 'Server & Infrastructure Support',
        icon: p8,
        items: [
          'Cost optimization of cloud usage.',
          'Load balancing & auto-scaling setup.',
          'Log monitoring & error tracking setup.',
          'Security hardening (firewalls, DDOS protection).'
        ]
      },
      {
        title: 'Console Management (Play Store / App Store)',
        icon: p9,
        items: [
          'App review & rejection handling with Google/Apple.',
          'Store listing optimization (ASO keywords, description updates).',
          'Managing in-app purchase subscriptions on consoles.',
          'Setting up A/B testing for store listings.'
        ]
      },
      {
        title: 'Bug Fixes & Issue Resolution',
        icon: p10,
        items: [
          'Resolving API integration issues.',
          'Debugging payment gateway issues.',
          'Performance tuning for slow modules.',
          'Patching security vulnerabilities.',
          'Fixing data sync errors across platforms.'
        ]
      },
      {
        title: 'Monitoring & Analytics',
        icon: p11,
        items: [
          'Monitoring churn rate & retention metrics.',
          'Tracking server load vs traffic spikes.',
          'Monitoring app store reviews & ratings.',
          'Analyzing heatmaps & click tracking (Hotjar, FullStory).'
        ]
      },
      {
        title: 'Compliance & Security Support',
        icon: p12,
        items: [
          'Securing APIs with updated tokens.',
          'SSL pinning implementation.'
        ]
      }
    ]
  },
  {
    id: 'scale',
    title: 'Scale Care Plan',
    frequency: 'Pay As You Go',
    priceUSD: '',
    priceINR: '',
    priceCustom: 'Growth Care Plan - Maintain & Improve +',
    icon: p7,
    description: '',
    serviceSections: [
      {
        title: 'App Enhancements / Development Support',
        icon: p8,
        items: [
          'Adding small new features (minor modules).',
          'UI/UX improvements based on user feedback.',
          'Integration of third-party APIs.',
          'Implementing analytics & event tracking.',
          'Improving onboarding flow for better UX.',
          'Adding multilingual support.',
          'Optimizing for newer OS versions.',
          'Making app compatible with new devices (foldables, tablets).',
          'Improving offline support for apps.',
          'Adding push notification campaigns.'
        ]
      },
      {
        title: 'Monitoring & Analytics',
        icon: p11,
        items: [
          'Setting up dashboards for KPIs.',
          'SEO monitoring for web apps.',
          'Monitoring competitor app updates.'
        ]
      },
      {
        title: 'Compliance & Security Support',
        icon: p12,
        items: [
          'GDPR / HIPAA compliance updates.',
          'Two-factor authentication setup.',
          'Data encryption & masking updates.',
          'Annual penetration testing.',
          'Ensuring accessibility compliance (WCAG).'
        ]
      },
      {
        title: 'Customer Support Integration',
        icon: p9,
        items: [
          'Chatbot integration (Drift, Intercom, Tidio).',
          'Support ticketing system integration (Zendesk, Freshdesk).',
          'Email support workflow setup.',
          'FAQ & knowledge base updates.',
          'Setting up in-app customer feedback form.',
          'Handling push for new user announcements.',
          'Adding WhatsApp/Telegram support channels.'
        ]
      },
      {
        title: 'DevOps & Automation',
        icon: p10,
        items: [
          'CI/CD pipeline maintenance.',
          'Automated testing integration.',
          'Code repository management (Git).',
          'Automated backup of builds & releases.',
          'Deployment automation for faster hotfixes.',
          'Security scans in CI/CD.',
          'Containerization updates (Docker/Kubernetes).'
        ]
      },
      {
        title: 'Other Support Services',
        icon: p13,
        items: [
          'Training client team on app usage.',
          'Documentation updates for new features.',
          'Creating release notes for app updates.',
          'Consulting on scaling roadmap.',
          'Competitive benchmarking analysis.',
          'UI/UX audits every quarter.',
          'Migration support (if moving servers/cloud providers).',
          'Helping with integration of marketing tools (Google Ads SDK, Facebook Pixel).',
          'Data migration support when upgrading DB versions.',
          'End-of-life planning for older app versions.'
        ]
      }
    ]
  }
]

const developmentPricingPlans = [
  {
    id: 'basic-dev',
    title: 'Basic',
    frequency: '3 Months Long Project',
    priceUSD: '$2,000',
    priceINR: '',
    icon: p5,
    description: '',
    serviceSections: [
      {
        title: 'First Month',
        icon: p14,
        items: [
          'Requirement gathering',
          'Wireframing',
          'Basic setup (e.g., database schema, backend framework like Node.js/React)'
        ]
      },
      {
        title: 'Second Month',
        icon: p14,
        items: [
          'Develop 2-3 core features per month (e.g., user authentication, basic CRUD operations).'
        ]
      },
      {
        title: 'Third Month',
        icon: p14,
        items: [
          'QA',
          'Security Integrations',
          'Demo Calls',
          'Deployment to Stores + Delivery'
        ]
      }
    ]
  },
  {
    id: 'standard-dev',
    title: 'Standard',
    frequency: '6 Months Long Project',
    priceUSD: '$3,000',
    priceINR: '',
    icon: p6,
    description: '',
    serviceSections: [
      {
        title: 'First Month',
        icon: p14,
        items: [
          'Requirement gathering',
          'Wireframing',
          'Basic setup (e.g., database schema, backend framework like Node.js/React)'
        ]
      },
      {
        title: 'Second to 4th Month',
        icon: p14,
        items: [
          'Core Development',
          '3rd Party API Integrations',
          'Bi-Weekly Sprints'
        ]
      },
      {
        title: 'Last Month',
        icon: p14,
        items: [
          'QA',
          'Security Integrations',
          'Demo Calls',
          'Deployment to Stores + Delivery'
        ]
      }
    ]
  },
  {
    id: 'premium-dev',
    title: 'Premium',
    frequency: '9/12 Months Long Project',
    priceUSD: '$5,000',
    priceINR: '',
    icon: p7,
    description: '',
    serviceSections: [
      {
        title: 'First Two Months',
        icon: p14,
        items: [
          'Requirement gathering',
          'Wireframing',
          'Basic setup (e.g., database schema, backend framework like Node.js/React)'
        ]
      },
      {
        title: 'Third to 6th (8th) Months',
        icon: p14,
        items: [
          'Core Development',
          '3rd Party API Integrations',
          'Bi-Weekly Sprints'
        ]
      },
      {
        title: 'Last Two Month',
        icon: p14,
        items: [
          'QA',
          'Security Integrations',
          'Demo Calls',
          'Deployment to Stores + Delivery'
        ]
      }
    ]
  }
]

const videoEditingPricingPlans = [
  {
    id: 'long-form-videos',
    title: 'Long Form Videos',
    frequency: 'Podcast Video Editing',
    priceUSD: '$5,000',
    priceINR: '',
    icon: p7,
    description: '',
    serviceSections: [
      {
        title: 'Video Editing Services',
        icon: p8,
        items: [
          '2 Videos / Month (60 minutes of each video maximum)',
          'Intro Highlight Creation',
          'Multi-Camera Editing (for podcasts, events, interviews)',
          'Sound Design & Audio Cleanup (noise removal, EQ, mixing, mastering)',
          'Make Reels from that podcast - Repurposing Long Videos into Multiple Shorts (Upto 5 Reels)',
          'Platform-Specific Optimization (ANY ONE)',
          'Vertical (Reels/Shorts/TikTok)',
          'Horizontal (YouTube)',
          'Square (Instagram feed, Linkedin)'
        ]
      }
    ]
  },
  {
    id: 'social-media-services',
    title: 'Social Media Account Services',
    frequency: 'Per Month',
    priceUSD: '$5,000',
    priceINR: '',
    icon: p7,
    description: '',
    serviceSections: [
      {
        title: 'Social Media Management',
        icon: p9,
        items: [
          '1 Platform & 1 Account Per Month',
          'Hashtag Research & Strategy (niche-focused hashtags per post)',
          'Keyword Research',
          'Content Calendar Creation (weekly/monthly posting schedule) + Post videos on particular date & time',
          'Engagement Optimization (best time to post, trending audio usage)',
          'Community Management',
          'Replying to comments, basic engagement',
          'Influencer Collaboration Editing (joint reels, reaction edits)'
        ]
      }
    ]
  },
  {
    id: 'video-shooting',
    title: 'Video Shooting',
    frequency: 'Per Session',
    priceUSD: '$5,000',
    priceINR: '',
    icon: p7,
    description: '',
    serviceSections: [
      {
        title: 'Video Production Services',
        icon: p10,
        items: [
          'Podcast Shooting (Upto. 2 Hours)',
          'Reel Shooting (Upto 2 Hours)',
          'YouTube Video Shooting (Upto 2 Hours)'
        ]
      }
    ]
  }
]

// Icons for included/not included status (using SVG checkmark and cross)
const checkmarkIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%2315803d' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E"
const crossIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23c0392b' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E"

const uiuxTableData = {
  heading: 'UI/UX DESIGN PRICE',
  columns: [
    { id: 'pkg1', title: 'Package 1', priceUSD: '$500', priceINR: '₹30,000' },
    { id: 'pkg2', title: 'Package 2', priceUSD: '$1000', priceINR: '₹70,000' },
    { id: 'pkg3', title: 'Package 3', priceUSD: '$1500', priceINR: '₹1,00,000' }
  ],
  icons: {
    included: checkmarkIcon,
    notIncluded: crossIcon
  },
  rows: [
    {
      feature: 'Pages Included',
      values: {
        pkg1: { text: 'Up to 20 Pages' },
        pkg2: { text: 'Up to 40 Pages' },
        pkg3: { text: 'Up to 60 Pages' }
      }
    },
    {
      feature: 'Type of Design',
      values: {
        pkg1: { text: 'Creative Custom Mobile App or Web App Design' },
        pkg2: { text: 'Creative Custom Mobile App or Web App Design' },
        pkg3: { text: 'Creative Custom Mobile App or Web App Design' }
      }
    },
    {
      feature: 'Interactive App Console & Google Console Screenshot Designs',
      values: {
        pkg1: { text: 'Included', status: 'included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Themes',
      values: {
        pkg1: { text: '1 Theme (Light or Dark)' },
        pkg2: { text: '1 Theme (Light or Dark)' },
        pkg3: { text: '1 Theme (Light or Dark)' }
      }
    },
    {
      feature: 'Additional Theme Option',
      values: {
        pkg1: { text: '+$150 / ₹7,500' },
        pkg2: { text: '+$300 / ₹15,000' },
        pkg3: { text: '+$600 / ₹30,000' }
      }
    },
    {
      feature: 'Responsive Web App Design',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Not Included', status: 'not_included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Web Design – Mobile Version',
      values: {
        pkg1: { text: '+$50 / ₹3,000' },
        pkg2: { text: '+$100 / ₹5,000' },
        pkg3: { text: '+$300 / ₹15,000' }
      }
    },
    {
      feature: 'Revisions',
      values: {
        pkg1: { text: '3 Revisions for first 4 pages' },
        pkg2: { text: '3 Revisions for first 4 pages' },
        pkg3: { text: '3 Revisions for first 4 pages' }
      }
    },
    {
      feature: 'Design System',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Lite Version (Typography, Color, Button Styles)' },
        pkg3: { text: 'Full Design System (Typography, Components, Patterns)' }
      }
    },
    {
      feature: 'New Revision Add-on',
      values: {
        pkg1: { text: '+$100 / ₹5,000 (Up to 5 Screens)' },
        pkg2: { text: '+$100 / ₹5,000 (Up to 5 Screens)' },
        pkg3: { text: '+$100 / ₹5,000 (Up to 5 Screens)' }
      }
    },
    {
      feature: 'Responsive Web Design Included By Default',
      values: {
        pkg1: { text: 'No', status: 'not_included' },
        pkg2: { text: 'No', status: 'not_included' },
        pkg3: { text: 'Yes', status: 'included' }
      }
    },
    {
      feature: 'Suitable For',
      values: {
        pkg1: { text: 'Small apps or startups seeking basic structure' },
        pkg2: { text: 'Mid-size projects needing extended coverage + design system lite' },
        pkg3: { text: 'Large projects needing scalability, responsive layouts, and full design system' }
      }
    }
  ],
  
}

const reelsShortsTableData = {
  heading: 'REELS/SHORTS',
  columns: [
    { id: 'pkg1', title: 'Package 1', priceUSD: '', priceINR: '₹6,000' },
    { id: 'pkg2', title: 'Package 2', priceUSD: '', priceINR: '₹10,000' },
    { id: 'pkg3', title: 'Package 3', priceUSD: '', priceINR: '₹17,500' }
  ],
  rows: [
    {
      feature: 'Videos Per Month',
      values: {
        pkg1: { text: '5 Videos' },
        pkg2: { text: '10 Videos' },
        pkg3: { text: '20 Videos' }
      }
    },
    {
      feature: 'Video Duration',
      values: {
        pkg1: { text: '60 Seconds Max (Per Video)' },
        pkg2: { text: 'Up to 60-90 seconds' },
        pkg3: { text: 'Up to 60-90 seconds' }
      }
    },
    {
      feature: 'Sync Audio + Video',
      values: {
        pkg1: { text: 'Included (If needed for explanation videos)', status: 'included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Background Music',
      values: {
        pkg1: { text: 'Included', status: 'included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Beat Sync with Audio, Images, Videos',
      values: {
        pkg1: { text: 'Included', status: 'included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Video Effects',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Including Elements',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Included', status: 'included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Subtitles',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Included (Script required from client)', status: 'included' },
        pkg3: { text: 'Included (Script required from client)', status: 'included' }
      }
    },
    {
      feature: 'Remove Background',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Not Included', status: 'not_included' },
        pkg3: { text: 'Included (At specific points to add elements)', status: 'included' }
      }
    },
    {
      feature: 'Dynamic Sound Effects',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Not Included', status: 'not_included' },
        pkg3: { text: 'Included (During elements)', status: 'included' }
      }
    },
    {
      feature: 'Motion Graphics',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Not Included', status: 'not_included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Cover Image',
      values: {
        pkg1: { text: 'Not Included', status: 'not_included' },
        pkg2: { text: 'Not Included', status: 'not_included' },
        pkg3: { text: 'Included', status: 'included' }
      }
    },
    {
      feature: 'Suitable For',
      values: {
        pkg1: { text: 'Basic video editing needs with simple syncing and music' },
        pkg2: { text: 'Enhanced videos with effects, elements and subtitles' },
        pkg3: { text: 'Professional videos with advanced graphics, effects, and dynamic elements' }
      }
    }
  ],
  icons: {
    included: checkmarkIcon,
    notIncluded: crossIcon
  },
  expandable: true
}

const additionalServicesTableData = {
  heading: 'ADDITIONAL SERVICES (ADD-ONS)',
  columns: [
    { id: 'feature', title: 'Feature', priceUSD: '', priceINR: '' },
    { id: 'pricing', title: 'Pricing', priceUSD: '', priceINR: '' },
    { id: 'details', title: 'Details', priceUSD: '', priceINR: '' }
  ],
  rows: [
    {
      feature: 'Thumbnail Design',
      values: {
        feature: { text: 'Thumbnail Design' },
        pricing: { text: '₹800 per video' },
        details: { text: 'Eye-catching thumbnails optimized for higher click-through rates' }
      }
    },
    {
      feature: 'YouTube Video Title + Description Writing',
      values: {
        feature: { text: 'YouTube Video Title + Description Writing' },
        pricing: { text: '₹650 per video' },
        details: { text: 'SEO-optimized titles and descriptions for better discoverability' }
      }
    },
    {
      feature: 'Keyword Research',
      values: {
        feature: { text: 'Keyword Research' },
        pricing: { text: '₹750 per video' },
        details: { text: 'Comprehensive keyword analysis for maximum video visibility' }
      }
    },
    {
      feature: 'Content Analysis + Script Writing + Caption Generation',
      values: {
        feature: { text: 'Content Analysis + Script Writing + Caption Generation' },
        pricing: { text: '₹1,200 per post' },
        details: { text: 'Full content strategy and creation for each video post' }
      }
    },
    {
      feature: 'Video Upload + Calendar Management',
      values: {
        feature: { text: 'Video Upload + Calendar Management' },
        pricing: { text: '₹2,500 per month' },
        details: { text: 'Complete handling of publishing schedule and platform management' }
      }
    },
    {
      feature: 'Video Shooting (Offline) For Reels Only',
      values: {
        feature: { text: 'Video Shooting (Offline) For Reels Only' },
        pricing: { text: '₹3,500 per session' },
        details: { text: 'Professional filming for short-form vertical video content' }
      }
    },
    {
      feature: 'Voiceover',
      values: {
        feature: { text: 'Voiceover' },
        pricing: { text: '₹950 per video' },
        details: { text: 'Professional voice talent to narrate your content' }
      }
    },
    {
      feature: 'Subtitles/Closed Captions',
      values: {
        feature: { text: 'Subtitles/Closed Captions' },
        pricing: { text: '₹350 per minute' },
        details: { text: 'Accurate subtitles to improve accessibility and engagement' }
      }
    }
  ],
  icons: {
    included: checkmarkIcon,
    notIncluded: crossIcon
  },
  expandable: true,
  isAddOnsTable: true
}

const videoEditingServiceData = {
  cards: videoEditingPricingPlans,
  tables: [
    reelsShortsTableData,
    additionalServicesTableData
  ]
}

export const pricingPlansByService = {
  support: servicePricingPlans,
  development: developmentPricingPlans,
  uiux: uiuxTableData,
  video: videoEditingServiceData
}
